import React, {Component} from 'react';
import ExternalLink from '../ExternalLink/ExternalLink.jsx';

class CenterNavButton extends Component {
	render() {
		return (
			<ExternalLink href="/" data-tracking={JSON.stringify({eventAction: 'XFINITY'})}>
				<div className="polaris-xfinity-logo text-center">
					<span className="vh">xfinity</span>
				</div>
			</ExternalLink>
		);
	}
}

export default CenterNavButton;



/** WEBPACK FOOTER **
 ** ./client/components/Common/Nav/CenterNavButton.jsx
 **/